import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { STRIPE_ONBOARDING_FULL_PATH } from "@src/appV2/redesign/Payments/Onboarding/paths";
import { useShouldUseNewStripeOnboarding } from "@src/appV2/Stripe/useShouldUseNewStripeOnboarding";
import { useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

interface ShiftBottomSetupPaymentsCardProps {
  shiftId: string;
}

export function ShiftBottomSetupPaymentsCard(props: ShiftBottomSetupPaymentsCardProps) {
  const { shiftId } = props;
  const history = useHistory();
  const shouldUseNewStripeOnboarding = useShouldUseNewStripeOnboarding();
  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      title="Set up your Stripe account"
      description="Our payments partner still needs some information in order to pay you. All debit cards and most bank account types are eligible for instant payouts!"
      illustrationType="instant-pay"
      footer={
        <Button
          fullWidth
          variant="contained"
          size="medium"
          onClick={() => {
            logEvent(APP_V2_USER_EVENTS.SHIFT_DETAILS_CTA_SETUP_PAYMENTS, {
              shiftId,
            });
            if (shouldUseNewStripeOnboarding) {
              logEvent(APP_V2_USER_EVENTS.PAYMENTS_ONBOARDING_ENTRYPOINT_CLICKED, {
                sourceUI: "shift-booking",
              });
            }

            history.push(
              shouldUseNewStripeOnboarding
                ? STRIPE_ONBOARDING_FULL_PATH
                : DeprecatedGlobalAppV1Paths.PAYMENT_SERVICE_ONBOARDING
            );
          }}
        >
          Setup payments
        </Button>
      }
    />
  );
}
